module.exports = __webpack_public_path__ + "img/dash-icon7.cfee4cc7.png";